import { useEffect, useState } from 'react';
import { useStores } from 'index';
import { SessionEnrichment } from 'types/models/SessionEnrichment';
import { IResult } from 'services/Result';
import { AxiosResponseHelper } from 'utilities/AxiosResponseHelper';

/**
 * SharedCalculator enrichment (free-kick wall + targets) for one kick, from `api/SessionEnrichment`. A nice-to-have
 * overlay: it loads best-effort, never blocks the caller, and failures only log. Pass `enabled = false` until the
 * 3D view (the only consumer of the wall) is actually shown.
 */
export function useSessionEnrichment(
  sessionId: string | undefined,
  measurementId: string | undefined,
  enabled: boolean = true,
): SessionEnrichment | null {
  const { apiServiceAxiosInstance: api } = useStores();
  const [enrichment, setEnrichment] = useState<SessionEnrichment | null>(null);

  useEffect(() => {
    if (!enabled || !sessionId || !measurementId) return undefined;
    let cancelled = false;
    setEnrichment(null);
    api
      .get<IResult<SessionEnrichment>>(
        `api/SessionEnrichment?sessionId=${encodeURIComponent(sessionId)}&measurementId=${encodeURIComponent(measurementId)}`,
      )
      .then((response) => {
        if (!cancelled && AxiosResponseHelper.IsSuccessfulResponse(response) && response.data?.data) setEnrichment(response.data.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn('[enrichment] fetch failed', err);
      });
    return () => { cancelled = true; };
  }, [enabled, sessionId, measurementId, api]);

  return enrichment;
}
